export default __webpack_public_path__ + "./fonts/information.2a7d8b07.svg";